const LINKS = {
  DESIGN_DAIKOU: "/customer_support/services_form.html",
  HARNESS: "/kiban/hns/csHnsEst.do",
  METALMASK: "/kiban/com/csComMetalMaskEntOrd:def.do?ru=1",
  筐体: "/enclosure/",
  PARTS_PROCUREMENT: "/kiban/cmp/csCmpEst.do",
  RIGID_14LAYERS_OR_MORE: "/product/form/f_mtl_rigid.html",
  CALENDER: "/information/business_calendar.html",
  DELIVERY_ZERO: "/services/product/delivery-zero.html",
  PARTS_LIST_TEMPLATE: "/information/data/parts_list.xlsx",
  LOGOUT: "/kiban/csComLogout.do",
  LOGIN: "/kiban/csComLogin.do",
  MYPAGE: "/kiban/com/csComTop.do",
  SIGNUP: "/kiban/signup",
} as const

export default LINKS
